import { useMutation, useQueryClient } from "react-query";
import { sendSms, SMS_QUERY_KEYS } from "@/services/sms";
/** Mutation hook that enqueues an SMS and refreshes the patient's history. */
export function useSendSms(patientId) {
  var queryClient = useQueryClient();
  return useMutation(function (payload) {
    return sendSms(payload);
  }, {
    onSuccess: function onSuccess() {
      queryClient.invalidateQueries(SMS_QUERY_KEYS.patientMessages(patientId));
    }
  });
}